import React, { useState } from "react";
import FormContentWrapper from "Components/FormContentWrapper";
import { useFormData } from "Contexts/FormDataContext";
import { useSession } from "Contexts/SessionContext";
import usePageContextUpdate from "Hooks/usePageContextUpdate";
import PrivacySendFormContent from "Components/PrivacySend/PrivacySendFormContent";
import PrivacySendInfoContent from "Components/PrivacySend/PrivacySendInfoContent";
import useSessionNavigate from "Hooks/useSessionNavigate";
import privacyStyles from "Styles/components/PrivacySend.module.css";
import bellEmoji from "Assets/emoji/bell.svg";
import { getPageNumber } from "Data";
import {
  submitToHubSpot,
  formatFieldsForHubSpot,
  getSessionProperties,
  mapFormDataToHubSpotFields,
} from "Lib/hubspot-utils";
import { getSessionWithContact } from "Lib/session-utils";

const PrivacySendPage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { sessionNavigate } = useSessionNavigate();

  usePageContextUpdate();

  const {
    updatePrivacyConsent,
    currentFormData: { companyName },
  } = useFormData();

  const { updateSession, sessionData, sessionCode } = useSession();

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      updatePrivacyConsent(true);

      if (sessionCode) {
        const sessionResult = await getSessionWithContact(sessionCode);

        if (sessionResult.success && sessionResult.data) {
          const { contact, responses } = sessionResult.data;

          const formData = mapFormDataToHubSpotFields(
            { responses },
            contact || {},
          );
          const sessionProps = getSessionProperties(sessionCode, "Completed");

          const hubspotData = {
            ...formData,
            ...sessionProps,
          };

          console.log("[HubSpot] Session data:", { contact, responses });
          console.log("[HubSpot] Mapped form data:", formData);
          console.log("[HubSpot] Session properties:", sessionProps);
          console.log("[HubSpot] Final hubspot data:", hubspotData);

          const fields = formatFieldsForHubSpot(hubspotData);
          console.log("[HubSpot] Formatted fields for submission:", fields);

          const result = await submitToHubSpot(fields, {
            pageName: "Privacy Send - Form Complete",
          });
          console.log("[HubSpot] Submission result:", result);
        }
      }

      await updateSession({
        current_page: getPageNumber("privacy-send"),
        status: "completed",
        responses: {
          ...sessionData?.responses,
          privacy_consent: true,
        },
      });

      sessionNavigate("/complete");
    } catch (error) {
      console.error("Error submitting form:", error);
      setIsSubmitting(false);
    }
  };

  return (
    <section className="privacyWrapper">
      <div className={privacyStyles.headerSection}>
        <img
          src={bellEmoji}
          alt="Bell Emoji"
          className={privacyStyles.headerEmoji}
        />
        <h2 className={privacyStyles.headerHeading}>
          <svg
            width="16"
            height="29"
            viewBox="0 0 16 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.894427"
              y1="0.447318"
              x2="14.8944"
              y2="28.4473"
              stroke="white"
              strokeWidth="2"
            />
          </svg>
          <span style={{ padding: "0 1rem" }}>
            恭喜！你已完成行銷競爭力健檢！
          </span>
          <svg
            width="16"
            height="29"
            viewBox="0 0 16 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.894674"
              y1="28.446"
              x2="14.8971"
              y2="0.44723"
              stroke="white"
              strokeWidth="2"
            />
          </svg>
        </h2>
      </div>
      <FormContentWrapper
        infoContent={<PrivacySendInfoContent companyName={companyName} />}
        formFieldContent={
          <PrivacySendFormContent
            submitCB={handleSubmit}
            isSubmitting={isSubmitting}
          />
        }
        formFieldsClassName={privacyStyles.formContentFields}
      />
    </section>
  );
};

export default PrivacySendPage;
